export default __webpack_public_path__ + "static/media/copy.5fe487b3.svg";